import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import ListBelts from '../../../pages/ListBelts';
import ListBeltsMobile from '../../MobileComponents/Belts/ListBeltsMobile';

const ListBeltResponsive = () => {
    const { isMobile } = useResponsiveRedux();

    return isMobile ? <ListBeltsMobile /> : <ListBelts />;
};

export default ListBeltResponsive;